import styled from "styled-components";
import { flexbox, variant } from "styled-system";
import propTypes from "@styled-system/prop-types";

import Box from "./Box";

const Flex = styled(Box)`
  ${flexbox}
  ${props =>
    variant({
      variants: {
        borderDividerBottom: {
          position: "relative",
          "&:after": {
            content: "''",
            position: "absolute",
            bottom: "16px",
            left: "0",
            width: "54px",
            height: "1px",
            backgroundColor: "#80B2B8",
          },
        },
        borderDividerTopGrey: {
          position: "relative",
          "&:before": {
            content: "''",
            position: "absolute",
            top: "16px",
            left: "0",
            width: "54px",
            height: "1px",
            backgroundColor: "forms.border",
          },
        },
        none: {
          "&:before": {
            content: "none",
          },
        },
      },
    })}
`;

Flex.displayName = "Flex";

Flex.defaultProps = {
  display: "flex",
};

Flex.propTypes = {
  ...propTypes.flexbox,
};

export default Flex;
